import { forwardRef } from 'react'
import { Search, SlidersHorizontal, X } from 'lucide-react'
import type { FilterChip } from './leadFilterModel'

export const LeadFilters = forwardRef<HTMLButtonElement, {
  query: string
  onQueryChange: (query: string) => void
  chips?: FilterChip[]
  onOpenFilters?: () => void
  onRemoveChip?: (chip: FilterChip) => void
  onClearAll?: () => void
}>(function LeadFilters({ query, onQueryChange, chips = [], onOpenFilters, onRemoveChip, onClearAll }, filterButtonRef) {
  return (
    <div className="leads-toolbar">
      <div className="leads-toolbar-row">
        <label className="search-field">
          <Search aria-hidden="true" size={18} />
          <span className="sr-only">Search leads</span>
          <input
            onChange={(event) => onQueryChange(event.target.value)}
            placeholder="Search company, owner, email or phone"
            type="search"
            value={query}
          />
        </label>
        {onOpenFilters ? (
          <button
            aria-haspopup="dialog"
            className={`filter-trigger${chips.length ? ' has-filters' : ''}`}
            onClick={onOpenFilters}
            ref={filterButtonRef}
            type="button"
          >
            <SlidersHorizontal aria-hidden="true" size={16} strokeWidth={1.9} />
            Filter
            {chips.length ? <span className="filter-trigger-count" aria-label={`${chips.length} active`}>{chips.length}</span> : null}
          </button>
        ) : null}
      </div>

      {chips.length ? (
        <ul aria-label="Active filters" className="filter-chips">
          {chips.map((chip) => (
            <li className="filter-chip" key={chip.id}>
              <span>{chip.label}</span>
              <button aria-label={`Remove ${chip.label}`} onClick={() => onRemoveChip?.(chip)} type="button">
                <X aria-hidden="true" size={13} strokeWidth={2.2} />
              </button>
            </li>
          ))}
          <li>
            <button className="filter-chips-clear" onClick={onClearAll} type="button">Clear all</button>
          </li>
        </ul>
      ) : null}
    </div>
  )
})
